<ng-container *ngIf="singleDateEnabled">
  <mis-input type="rounded" [class]="customStyle">
    <input
      misTzDp
      misInput
      type="text"
      readonly
      class="date-input"
      [dpConfig]="datepickerConfig"
      [datesDisabled]="datesDisabled"
      placeholder="Select"
      (dateChange)="onDateChange($event)"
      [selectedDate]="selectedDate1"
      positionX="end"
      [value]="selectedDate1[selectedDate1.length-1]"
    />
  </mis-input>

 <!--  <input
    style="  
      outline: none;
      text-overflow: ellipsis;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      text-align: start;
      background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjYgNS40NTQ1NUgxNi45VjRIMTUuNVY1LjQ1NDU1SDguNVY0SDcuMVY1LjQ1NDU1SDYuNEM1LjYzIDUuNDU0NTUgNSA2LjEwOTA5IDUgNi45MDkwOVYxOC41NDU1QzUgMTkuMzQ1NSA1LjYzIDIwIDYuNCAyMEgxNy42QzE4LjM3IDIwIDE5IDE5LjM0NTUgMTkgMTguNTQ1NVY2LjkwOTA5QzE5IDYuMTA5MDkgMTguMzcgNS40NTQ1NSAxNy42IDUuNDU0NTVaTTE3LjYgMTguNTQ1NUg2LjRWOS4wOTA5MUgxNy42VjE4LjU0NTVaIiBmaWxsPSIjNkE3MzdEIi8+Cjwvc3ZnPgo=')
        right center / 40px 25px no-repeat;
      white-space: nowrap;
      text-indent: 4px;
      width: 254px;
      height: 32px;
      font-size: 14px;
    "
    type="text"
    placeholder="Select Date"
    class="form-control"
    misDateRangePicker
    placement="bottom"
    id="dateRangePicker-input"
    [misConfig]="{
      maxDateRange: 30,
      ranges: ranges,
      rangeInputFormat: 'DD/MM/YYYY'
    }"
    (click)="open(dateRange)"
    (bsValueChange)="onValueChange($event, dateRange)"
    #dateRange="misDateRangePicker"
    autocomplete="off"
  /> -->
</ng-container>
​
<ng-container *ngIf="!singleDateEnabled">
  <mis-input type="rounded" [class]="customStyle">
    <!-- <input
      misTzDrp
      misInput
      type="text"
      readonly
      class="date-input"
      [dpConfig]="datepickerConfig"
      [datesDisabled]="datesDisabled"
      placeholder="Select"
      (dateChange)="onDateRangeChange($event)"
      [selectedDates]="selectedDateRange"
      positionX="end"
      [value]="selectedDateRange.startDate + ' - ' + selectedDateRange.endDate"
    /> -->

    <!-- ---------------new cds calendar---------- -->
    <input  
    [placeholder]="selectedDateRange.startDate + ' - ' + selectedDateRange.endDate"
    misInput
    readonly
    misDateRangePicker 
    class="date-input"
    [value]="selectedDateRange.startDate + ' - ' + selectedDateRange.endDate"
    (bsValueChange)="selectDateRange($event)"  
    [maxDate]="maxValue"
    #sd="misDateRangePicker"
    [misConfig]="{ isAnimated: true, showClearButton: true, dateInputFormat: 'DD/MM/YYYY', clearPosition:'bottom' } "
    placement="bottom" 
    *ngIf="enableDateRangePicker"
    >
    <input misTzSdp misInput type="text" readonly [dpConfig]="specificDatepickerConfigs" 
            class="date-input" placeholder="Select" (dateChange)="onDateChange2($event)" [selectedDatesRange]="selectedDatesRange"
            [selectedDates]="selectedDates"  (dateChangeRange) ="onDateRangeSelect($event)" 
            [value]="specificSelectedDates" [isSPickerSelected]="true"  *ngIf="!enableDateRangePicker" positionX="end" [isSingleDatePickerEnable]="true"/>
  </mis-input>
  <!-- misTzDrp -->
  <!-- #sd="misDateRangePicker" -->
  <!-- [misConfig]="{ isAnimated: true, showClearButton: true, dateInputFormat: 'DD/MM/YYYY', clearPosition:'bottom' } " -->
</ng-container>
<!-- <ng-container *ngIf="!singleDateEnabled">
  <input
    style="
      outline: none;
      text-overflow: ellipsis;
      border: 0.5px solid rgb(199, 205, 212);
      padding-right: 0px;
      cursor: pointer;
      text-align: center;
      background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjYgNS40NTQ1NUgxNi45VjRIMTUuNVY1LjQ1NDU1SDguNVY0SDcuMVY1LjQ1NDU1SDYuNEM1LjYzIDUuNDU0NTUgNSA2LjEwOTA5IDUgNi45MDkwOVYxOC41NDU1QzUgMTkuMzQ1NSA1LjYzIDIwIDYuNCAyMEgxNy42QzE4LjM3IDIwIDE5IDE5LjM0NTUgMTkgMTguNTQ1NVY2LjkwOTA5QzE5IDYuMTA5MDkgMTguMzcgNS40NTQ1NSAxNy42IDUuNDU0NTVaTTE3LjYgMTguNTQ1NUg2LjRWOS4wOTA5MUgxNy42VjE4LjU0NTVaIiBmaWxsPSIjNkE3MzdEIi8+Cjwvc3ZnPgo=')
        left center / 40px 25px no-repeat;
      white-space: nowrap;
      text-indent: -70px;
    "
    type="text"
    placeholder="Duration"
    placement="bottom"
    class="form-control"
    (bsValueChange)="onValueChange($event, dateRange)"
    #dateRange="misDatePicker"
    misDatePicker
    [misConfig]="{
      rangeInputFormat: 'DD/MM/YYYY',
      dateInputFormat: 'DD/MM/YYYY'
    }"
  />
</ng-container> -->
